import { render, staticRenderFns } from "./ExtractFinancialDocuments.vue?vue&type=template&id=08757dc6&"
import script from "./ExtractFinancialDocuments.vue?vue&type=script&lang=js&"
export * from "./ExtractFinancialDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ExtractFinancialDocuments.vue?vue&type=style&index=0&id=08757dc6&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08757dc6')) {
      api.createRecord('08757dc6', component.options)
    } else {
      api.reload('08757dc6', component.options)
    }
    module.hot.accept("./ExtractFinancialDocuments.vue?vue&type=template&id=08757dc6&", function () {
      api.rerender('08757dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExtractFinancialDocuments.vue"
export default component.exports